<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">图片信息编辑</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>关联账号：</label>
          <el-select v-model="relateState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in relateStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType" :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div style="display: flex">
          <SearchUidOrPhone style="margin-right: 16px;" @confirm="openDialog($event)"/>
          <el-button type="primary" @click="funInfoImgDialog()">新建</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            border
            @cell-click="toggleSelection"
            v-loading="listLoading"
        >
          <!--          <el-table-column type="selection" width="55" />-->
          <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1"/>
          <el-table-column label="图片" v-if="checkColList.indexOf('图片') > -1" >
            <template #default="scope">
              <el-image style="width: 80px; height: 80px" :src="scope.row.avatarSmall" @click="showImg(scope.row)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column label="关联账号" v-if="checkColList.indexOf('用户信息') > -1">
            <template #default="scope">
              <UserInfoList v-if="scope.row.uid != 'YK2130181'" :row="scope.row" showList="name,phone,uid"/>
            </template>
          </el-table-column>
          <el-table-column label="用户信息" v-if="checkColList.indexOf('用户信息') > -1">
            <template #default="scope">
              <p>姓名：{{scope.row.name}}</p>
              <p>性别：{{scope.row.sex == 1 ? "男" : scope.row.sex == 2 ? "女" : "--"}}</p>
              <p>出生：{{scope.row.birthday}}</p>
              <p>身高：{{scope.row.height}}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1" class-name="cursor" >
            <template #default="scope">
              <el-space>
                <el-button type="primary" size="small" @click="handleEdit(scope.$index,scope.row)">编辑</el-button>
                <el-button type="primary" size="small" @click="downloadImg(scope.row)">预览</el-button>
                <el-button type="primary" size="small" @click="relationUser(scope.row)">关联账号</el-button>
              </el-space>
            </template>
          </el-table-column>
          <el-table-column property="" label="小记" v-if="checkColList.indexOf('小记') > -1" width="164" class-name="cursor">
            <template #default="scope">
              <UserRemark :user-remark-list="scope.row.userSmallRemarkList" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
// import BtnGroup from '../../components/BtnGroup'
import { getUserImgInfoPageList } from '../../api/url'
import { getFormData } from '../../api/api'
import Dialog from '../../assets/js/dialog'
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import ImgViewer from '../../assets/js/imageViewer'
import { common } from "@/assets/shared/select-constant";
import UserLog from "@/components/UserLog/UserLog";
import UserRemark from "@/components/Remark/UserRemark";
import UserRemarkDialog from "@/components/Remark/UserRemarkDialog";
import SearchUidOrPhone from '../../components/SearchUidOrPhone'
import InfoImgDialog from "./components/InfoImgDialog";
import searchInfoDialog from "./components/searchInfoDialog";
import RelationUserDialog from "./components/RelationUserDialog";
import DownloadImgDialog from "./components/DownloadImgDialog";

export default {
  name: "InfoImgList",
  components: { DatePickerRange, SearchComponents, UserRemark, SearchUidOrPhone },
  data() {
    return {

      sexArray: common.sexList,
      sex: common.sexList[0]['value'],

      relateStateArray: [
        { label: '不限', value: -1},
        { label: '已关联', value: 1},
        { label: '未关联', value: 2},
      ],

      relateState: -1,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '昵称', value : 2},
        {label : 'uid', value : 3},
        {label : '姓名', value : 4},
        {label : '小计', value : 5},
      ],
      searchType: 3,
      searchValue: '',

      //刷新组
      colList: ['创建时间', '图片', '关联账号', '用户信息', '操作', '小记'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

      dataSummary: [],

      infoImgForm: {},

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.sex = -1;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['relateState'] = this.relateState;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getUserImgInfoPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.pageDataList.map(item => {
            let userInfo = JSON.parse(item.userInfo)
            // console.log(userInfo)
            userInfo.forEach(e => {
              if( e.name == '出生'){
                item.birthday = e.value
              }
              if( e.name == '身高'){
                item.height = e.value
              }
            })
          })
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.avatar)
      ImgViewer.open({
        imgList: imgList
      })
    },

    toggleSelection(row, column, cell, event) {

      //小记
      if(column.label == '小记') {
        Dialog.open({
          title: '小记',
          component: UserRemarkDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userSmallRemarkList'] = JSON.parse(sessionStorage.getItem('userRemark'));
          }
        })
      }


    },

    //编辑
    handleEdit(index, row) {
      this.infoImgForm = Object.assign({}, row);
      this.funInfoImgDialog(index);
    },

    //创建/编辑 dialog
    funInfoImgDialog(idx = -1){
      let _title = '';
      if(idx > -1){
        _title = '编辑信息';
      }else{
        _title = '创建信息';
        this.infoImgForm = {userId: 0, id: 0};
      }
      Dialog.open({
        title: _title,
        component: InfoImgDialog,
        data: {
          infoImgForm: this.infoImgForm,
          idx: idx
        },
        confirm: (result) => {
          this.getPage()
          // if(idx > -1) {
          //   this.pageDataList[idx]['avatarSmall'] = result.src;
          //   this.pageDataList[idx]['avatar'] = result.src;
          //   this.pageDataList[idx]['userInfo'] = result.userInfo;
          //   this.pageDataList[idx]['descInfo'] = result.descInfo;
          //   this.pageDataList[idx]['name'] = result.obj.name;
          //   this.pageDataList[idx]['sex'] = result.obj.sex;
          //   this.pageDataList[idx]['birthday'] = result.obj.birthday;
          //   this.pageDataList[idx]['height'] = result.obj.height;
          // }else{
          //   this.getPage()
          // }
        }
      })
    },

    //搜索
    openDialog(e) {
      // console.log(e)
      Dialog.open({
        component: searchInfoDialog,
        data: {
          userForm: e,
          width: '500px'
        },
        confirm: () => {
          this.getPage()
        }
      })
    },

    // 关联账号
    relationUser(row) {
      Dialog.open({
        title: '',
        component: RelationUserDialog,
        data: {
          id: row.id,
          width: '500px'
        },
        confirm: (result) => {
          row.nickName = result.nickName;
          row.uid = result.uid;
          row.phone = result.phone;
          row.userId = result.userId;
        }
      })
    },

    // 预览图片
    downloadImg(row) {
      Dialog.open({
        title: '',
        component: DownloadImgDialog,
        data: {
          src: row.avatar,
          userInfo: JSON.parse(row.userInfo),
          descInfo: JSON.parse(row.descInfo)
        },
        close: () => {
          // let parent = document.getElementsByTagName('body')[0];
          // let childArr = document.getElementsByClassName('el-dialog__wrapper');
          // let child = childArr[childArr.length - 1];
          // parent.removeChild(child);
        }
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
